"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = require("lodash");
var _components = require("../../../components");
var _utils = require("../../../utils");
var _VideoControl = _interopRequireDefault(require("./VideoControl"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var iconsByType = {
  video: {
    on: 'camera-on',
    off: 'camera-off'
  },
  audio: {
    on: 'microphone-on',
    off: 'microphone-off'
  }
};
var DeviceSelectionControl = function DeviceSelectionControl(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'video' : _ref$type,
    _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? false : _ref$enabled,
    selectedDevice = _ref.selectedDevice,
    label = _ref.label,
    selectLabel = _ref.selectLabel,
    isMaximized = _ref.isMaximized,
    _ref$devices = _ref.devices,
    devices = _ref$devices === void 0 ? [] : _ref$devices,
    _ref$onChangeDevice = _ref.onChangeDevice,
    onChangeDevice = _ref$onChangeDevice === void 0 ? _lodash.noop : _ref$onChangeDevice,
    _ref$toggleEnabled = _ref.toggleEnabled,
    toggleEnabled = _ref$toggleEnabled === void 0 ? _lodash.noop : _ref$toggleEnabled;
  var iconType = iconsByType[type][enabled ? 'on' : 'off'];
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    active = _useState2[0],
    setActive = _useState2[1];
  var onOpen = function onOpen(open) {
    setActive(open);
  };
  var onChangeSelectedDevice = function onChangeSelectedDevice(value) {
    var device = devices.find(function (_ref2) {
      var deviceId = _ref2.deviceId;
      return deviceId === value;
    });
    onChangeDevice(device);
  };
  var isSelectVisible = !(0, _lodash.isEmpty)(devices) && isMaximized;
  var renderOptionContent = function renderOptionContent(device) {
    var isSelected = device.deviceId === (selectedDevice === null || selectedDevice === void 0 ? void 0 : selectedDevice.deviceId);
    if ((0, _utils.isMobile)()) {
      return device.label;
    }
    return isSelected ? /*#__PURE__*/_react.default.createElement(_components.Icon, {
      type: "check-16"
    }) : /*#__PURE__*/_react.default.createElement("span", {
      className: "pl-[16px]"
    });
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "relative"
  }, /*#__PURE__*/_react.default.createElement(_VideoControl.default, {
    label: label,
    iconType: iconType,
    isMaximized: isMaximized,
    onClick: toggleEnabled
  }), isSelectVisible && /*#__PURE__*/_react.default.createElement("div", {
    className: "absolute top-[2px] left-[calc(50%+24px)]"
  }, /*#__PURE__*/_react.default.createElement(_components.SelectInput, {
    desktopStyles: {
      wrapperStyles: 'w-[16px] bg-transparent mt-0 absolute right-[18px] top-[16px]',
      inputWrapperStyles: 'border-none !p-0 !text-white items-center',
      inputStyles: (0, _classnames.default)('!cursor-pointer w-[16px] !text-transparent !w-[22px] rounded-[2px]', {
        'bg-grey-55': active
      }),
      selectOptionsStyles: '!w-[240px] !bg-grey-75 !top-auto bottom-[calc(100%+18px)] text-left max-h-screen rounded-[4px]',
      iconStyles: 'rotate-180 left-[3px]'
    },
    mobileStyles: {
      selectWrapperStyles: 'border-none !pt-0 w-[16px] ml-[6px]',
      iconStyles: 'rotate-180 text-white absolute pointer-events-none'
    },
    name: "".concat(type, "-device"),
    autoComplete: "off",
    onChange: onChangeSelectedDevice,
    onOpen: onOpen,
    value: selectedDevice === null || selectedDevice === void 0 ? void 0 : selectedDevice.deviceId,
    customLabel: selectLabel && !(0, _utils.isMobile)() && /*#__PURE__*/_react.default.createElement("span", {
      className: "pl-[10px] tw-caption-medium"
    }, selectLabel)
  }, devices.map(function (device) {
    return /*#__PURE__*/_react.default.createElement(_components.SelectInput.Option, {
      value: device.deviceId,
      key: device.deviceId,
      className: (0, _classnames.default)('tw-caption-regular !flex-row !px-[10px] !py-[5px] md:', {
        '!text-white !bg-transparent ': !(0, _utils.isMobile)()
      }),
      description: (0, _utils.isMobile)() ? null : /*#__PURE__*/_react.default.createElement("span", {
        className: "pl-[10px]"
      }, device.label)
    }, renderOptionContent(device));
  }))));
};
DeviceSelectionControl.propTypes = {
  type: _propTypes.default.oneOf(['video', 'audio']).isRequired,
  enabled: _propTypes.default.bool.isRequired,
  onChangeDevice: _propTypes.default.func.isRequired,
  toggleEnabled: _propTypes.default.func.isRequired,
  selectedDevice: _propTypes.default.shape({
    deviceId: _propTypes.default.string.isRequired,
    kind: _propTypes.default.oneOf(['audioInput', 'videoInput']).isRequired,
    label: _propTypes.default.string.isRequired
  }),
  devices: _propTypes.default.arrayOf(_propTypes.default.shape({
    deviceId: _propTypes.default.string.isRequired,
    kind: _propTypes.default.oneOf(['audioInput', 'videoInput']).isRequired,
    label: _propTypes.default.string.isRequired
  }).isRequired).isRequired,
  label: _propTypes.default.string,
  selectlabel: _propTypes.default.string,
  isMaximized: _propTypes.default.bool
};
var _default = DeviceSelectionControl;
exports.default = _default;